import React, {useState} from 'react';
import {Values} from "Tools/Values";
import DeleteIcon from "@material-ui/icons/Delete";
import {Button, Dialog, DialogActions, DialogTitle} from "@material-ui/core";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IDeleteProps {
    onSubmit: () => Promise<void>;
}

const EntityDelete = ({onSubmit}: IDeleteProps) => {
    const [isOpened, setIsOpened] = useState(false);

    const onClose = () => {
        setIsOpened(false);
    };

    return (
        <React.Fragment>
            <RoundButton
                icon={<DeleteIcon/>}
                tooltipTitle={Values.getLocalizationValue("remove")}
                color={"red"}
                onClick={() => setIsOpened(!isOpened)}
            />

            <Dialog
                maxWidth={false}
                open={isOpened}
                onClose={() => onClose()}
                style={{padding:24}}
            >
                <DialogTitle id="person-dialog-title">
                    {Values.getLocalizationValue("areYouSureRemove")}
                </DialogTitle>

                <DialogActions style={{padding: 24}}>
                    <Button
                        variant={"outlined"}
                        onClick={() => onClose()}
                        color="default"
                    >
                        {Values.getLocalizationValue("cancel")}
                    </Button>

                    <Button
                        variant={"contained"}
                        onClick={() => onSubmit()}
                        color="primary"
                    >
                        {Values.getLocalizationValue("confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default EntityDelete;
